import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/quality/specifications/${id}`)
                    .then((res) => {
                        resolve(res.data.data.qualitySpecification);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ commit }, qualitySpecificationForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/quality/specifications", qualitySpecificationForm)
                    .then((res) => {
                        resolve(res.data.data.qualitySpecification);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, qualitySpecificationForm) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/quality/specifications/${qualitySpecificationForm.id}`,
                        qualitySpecificationForm
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, qualitySpecificationId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/quality/specifications/${qualitySpecificationId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ commit }, qualitySpecificationId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/quality/specifications/${qualitySpecificationId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        saveDocument({ commit }, documentForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/quality/specifications/documents", documentForm, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        deleteDocument({ commit }, qualitySpecificationDocumentId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/quality/specifications/documents/${qualitySpecificationDocumentId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {},
};
